import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, MapPinIcon, ShoppingBagIcon, XIcon } from 'lucide-react';
import { recentPurchases } from '../data/content';
export function FloatingElements() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [index, setIndex] = useState(0);
  const [cta, setCta] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const delay = index === 0 ? 5000 : 8000;
    const showTimer = window.setTimeout(() => setVisible(true), delay);
    const rotateTimer = window.setTimeout(() => {
      setVisible(false);
      setIndex(value => (value + 1) % recentPurchases.length);
    }, delay + 5500);
    return () => {
      window.clearTimeout(showTimer);
      window.clearTimeout(rotateTimer);
    };
  }, [dismissed, index]);
  useEffect(() => {
    const onScroll = () => setCta(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const [name, city, plan] = recentPurchases[index];
  return <>
      <AnimatePresence data-id="element-82" data-mp="drhx0ndveqfr">
        {visible && !dismissed && <motion.aside initial={{
        opacity: 0,
        y: 24,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.96
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="fixed bottom-4 left-4 z-[60] max-w-[300px] overflow-hidden rounded-2xl border-2 border-gold bg-ink p-3 pr-8 shadow-[0_18px_42px_rgba(0,0,0,.7)]" aria-live="polite" data-id="element-83" data-mp="dtcflv1o66go">
            <div aria-hidden="true" className="absolute inset-y-0 left-0 w-1.5 bg-gold" data-id="element-84" data-mp="11fiy5b8pz4l5" />
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-1.5 top-1.5 rounded p-1 text-zinc-500 transition-colors duration-150 ease-smooth hover:text-gold" aria-label="Cerrar notificación" data-id="element-85" data-mp="15jgvbgehi5bk">
              <XIcon className="h-3.5 w-3.5" data-id="element-86" data-mp="32k39ugq6nnci" />
            </button>
            <div className="flex gap-3" data-id="element-87" data-mp="3ga6p2nqnagsg">
              <span aria-hidden="true" className="h-fit rounded-full bg-gold p-2 text-ink" data-id="element-88" data-mp="3gb8ejx8er5tp">
                <ShoppingBagIcon className="h-5 w-5" data-id="element-89" data-mp="3bioy8sic5wl7" />
              </span>
              <div data-id="element-90" data-mp="3q84ng427xtys">
                <p className="flex items-center gap-1 text-[10px] font-black uppercase tracking-[.12em] text-gold" data-id="element-91" data-mp="3q7l6oqob1bmc">
                  <CheckCircle2Icon aria-hidden="true" className="h-3 w-3" data-id="element-92" data-mp="3l91hmheezjpr" /> Compra reciente
                </p>
                <p className="mt-1 text-xs leading-snug text-zinc-300" data-id="element-93" data-mp="3358i3gviwaw">
                  <b className="text-white" data-id="element-94" data-mp="3ubj5f09pwkev">{name}</b> compró el libro digital{' '}
                  <b className="text-gold" data-id="element-95" data-mp="24ui39zp4nnt8">{plan}</b>
                </p>
                <p className="mt-1 flex items-center gap-1 text-[10px] font-medium text-zinc-500" data-id="element-96" data-mp="1zw88hq7bep85">
                  <MapPinIcon aria-hidden="true" className="h-3 w-3 text-gold" data-id="element-97" data-mp="fe645v1i6eka" />
                  {city} · Argentina · hace {index * 6 + 2} min
                </p>
              </div>
            </div>
          </motion.aside>}
      </AnimatePresence>

      <AnimatePresence data-id="element-98" data-mp="6lcgpabwk8vc">
        {cta && <motion.a href="#pricing" initial={{
        y: 80,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 80,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="fixed bottom-3 left-3 right-3 z-50 rounded-2xl bg-gold py-3.5 text-center text-sm font-black uppercase text-ink shadow-[0_14px_34px_rgba(0,0,0,.6)] md:hidden" data-id="element-99" data-mp="an7i0etu2m94">
            Quiero mi Combo Completo →
          </motion.a>}
      </AnimatePresence>
    </>;
}